import { pharmacyCaptchaActions } from '../../../../actions/user/pharmacy/Account/captcha';

const initialState = {
  loading: false,
  error: null,
  captchaImage: null,
  captchaKey: null,
  successMessage: null
};

const pharmacyCaptchaReducer = (state = initialState, action) => {
  switch (action.type) {
    case pharmacyCaptchaActions.GENERATE_CAPTCHA.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        captchaImage: null,
        captchaKey: null
      };
    case pharmacyCaptchaActions.GENERATE_CAPTCHA.SUCCESS:
      return {
        ...state,
        loading: false,
        captchaKey: action.payload?.captcha_key || null,
        captchaImage: action.payload?.captcha_image || null,
        error: null
      };
    case pharmacyCaptchaActions.GENERATE_CAPTCHA.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case pharmacyCaptchaActions.VERIFY_CAPTCHA.REQUEST:
      return {
        ...state,
        captchaKey: null,
        loading: true,
        error: null
      };
    case pharmacyCaptchaActions.VERIFY_CAPTCHA.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        captchaKey: action.payload?.captcha_key || null,
        successMessage: action.payload?.message || 'CAPTCHA verified successfully'
      };
    case pharmacyCaptchaActions.VERIFY_CAPTCHA.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default pharmacyCaptchaReducer;
